// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Misc cash disbursement'"></sub-header>
    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
          <tr>
            <td>1.</td>
            <td>Total amount:</td>
            <td>
              <cash ng-model="\$ctrl.transaction.amount"
                ng-disabled="true"
                ng-required="true"></cash>
            </td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Payment for:</td>
            <td>
              <input
                required
                type="text"
                maxlength="512"
                ng-model="\$ctrl.transaction.remarks"/>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="misc-transaction__accounts-table table">
        <thead>
        <tr>
          <th>Nr.</th>
          <th>Account</th>
          <th>Debit amount</th>
          <th>Credit amount</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>1.</td>
          <td>
            <select disabled>
              <option>USER CASH ON HAND</option>
            </select>
          </td>
          <td>
            <cash ng-disabled="true"></cash>
          </td>
          <td>
            <cash value="\$ctrl.transaction.amount"
              ng-disabled="true"></cash>
          </td>
          <td></td>
        </tr>
        <tr ng-repeat="unit in \$ctrl.transaction.units">
          <td>{{\$index + 2 +'.'}}</td>
          <td>
            <selectize options="\$ctrl.accounts"
                       config="\$ctrl.selectConfig"
                       ng-model="unit.accountCode"
                       required>
            </selectize>
          </td>
          <td>
            <cash ng-model="unit.amount"
              ng-required="true"
              ng-change="\$ctrl.onUnitChange()"
              min="0.01">
            </cash>
          </td>
          <td>
            <cash ng-disabled="true"></cash>
          </td>
          <td>
            <a ng-if="true" class="btn btn-danger" ng-click="\$ctrl.removeAccount(unit.accountCode)">Remove</a>
          </td>
        </tr>
        <tr class="add-account">
          <td class="add-account__remarks"></td>
          <td>
            <span class="add-account__remarks-total"><strong>Total:</strong></span>
          </td>
          <td>
            <cash value="\$ctrl.transaction.amount"
              ng-disabled="true"></cash>
          </td>
          <td>
            <cash value="\$ctrl.transaction.amount"
              ng-disabled="true"></cash>
          </td>
          <td>
            <a
              class="btn btn-success"
              ng-click="\$ctrl.addNewAccount()">
              Add new
            </a>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.transactionForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.transactionForm.\$invalid"
          ng-click="\$ctrl.save()">
          Create
        </button>
      </div>
    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/misc-cash-disbursement/misc-cash-disbursement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;